import { faCommentAlt, faPen } from "@fortawesome/free-solid-svg-icons";
import { GSButton, GSInfoGroup, defaultGapping, defaultLayouts } from "golfstatus_react_components";
import React from "react";

const FIELD_TYPE_LABELS = {
  text: "Text",
  select: "Dropdown",
  number: "Number",
}

const TournamentPackageCustomFieldItem = (props) => {

  const {name, required, fieldType, onEdit, onResponses} = props

  const fieldInfoSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: name,
      },
      {
        type: "secondary no-wrap full-width",
        value: FIELD_TYPE_LABELS[fieldType] ?? fieldType,
      },
      {
        type: "secondary no-wrap full-width",
        value: required ? "Required" : "Not Required",
      },
    ]
  }

  const fieldInfoColumn ={
    fit: "stretch",
    sections: [
      {
        ...fieldInfoSection
      },
    ],
  }

  const actionColumn = {
    fit: "additional-info",
    sections: [
      {
        sectionItems: [
          {
            type: "primary no-wrap",
            sectionItemStyle: { ...defaultLayouts.hStack, ...defaultGapping.mediumGap },
            value: (
              <>
                <GSButton
                  type="light-grey"
                  buttonIcon={faPen}
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    onEdit?.();
                  }}
                />
                <GSButton
                  type="light-grey no-wrap mobile-icon"
                  buttonIcon={faCommentAlt}
                  title="Responses"
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    onResponses?.();
                  }}
                />
              </>
            ),
          },
        ],
      },
    ],
  }

  const getGroup = () => {
    let group = [{...fieldInfoColumn}, {...actionColumn}]
    return group
  }

  return <tournament-package-custom-field-item>
    <GSInfoGroup dataGroups={getGroup()}></GSInfoGroup>
  </tournament-package-custom-field-item>
}


export default TournamentPackageCustomFieldItem